// import fs from "@/components/series/fs.js";
// import { integer } from "vuelidate/lib/validators";

const state = {

};

const mutations = {

};

const actions = {

};



export default {
  state,
  mutations,
  actions
};
